export const DISPLAY_SUCCESS_NOTIFICATION = 'NOTIFICATIONS/DISPLAY_SUCCESS_NOTIFICATION';
export const DISPLAY_ERROR_NOTIFICATION = 'NOTIFICATIONS/DISPLAY_ERROR_NOTIFICATION';
export const DISPLAY_DEFAULT_NOTIFICATION = 'NOTIFICATIONS/DISPLAY_DEFAULT_NOTIFICATION';
